module.exports = __webpack_public_path__ + "img/lake-cabin-3.e97072d9.jpg";